// src/data/projectContent.js

const stoValuationProject = [
  {
    title: "Valoración de Tokens de Seguridad: Factores y Consideraciones",
    value: `
## Valoración de Tokens de Seguridad

La valoración de un **token de seguridad** está fuertemente influenciada por **factores del mercado fuera de la cadena (off-chain)**.

> El activo subyacente que se tokeniza es el principal determinante del valor del token.

---

## Tipos de Activos y Dividendos

Muchos tokens de seguridad representan:

- **Activos generadores de ingresos**, como arrendamientos de bienes raíces.
- **Instrumentos de deuda**, como pagarés respaldados por flujos de efectivo.

Estos tokens suelen distribuir **dividendos periódicos** a los titulares, lo cual debe ser considerado al momento de su valoración.  
Tokens que ofrecen mayores dividendos, por ejemplo, tienden a tener una **valoración inicial más alta**.

---

## Guía para Valorar un Token

El proyecto proporciona una guía simplificada para que se puedan valorar distintos tipos de tokens de seguridad, sin entrar en complejidades legales ni financieras avanzadas.

Entre los factores clave que influyen en la valoración están:

- Naturaleza del activo subyacente.
- Generación de ingresos futuros.
- Periodicidad y monto de los dividendos.
- Riesgo percibido del proyecto o empresa emisora.

---

## Aplicación Práctica

Esta información permite establecer criterios básicos para definir el **valor inicial del token** directamente dentro del contrato inteligente.  
Cada usuario podrá adaptar el nivel de profundidad del análisis según los objetivos y la complejidad del proyecto.

---

## Objetivo del Proyecto

El objetivo es que el usuario sea capaz de:

- Emitir un **token de seguridad respaldado por un activo**.
- Comprender los fundamentos que determinan su valoración.
- Integrar estos datos en su contrato sin requerir procesos legales complejos ni modelos financieros avanzados.

Gracias por continuar con este módulo del proyecto.
    `,
  },
];

export default stoValuationProject;
